import { render, staticRenderFns } from "./centralScheduling.vue?vue&type=template&id=6a56f6ca&scoped=true&"
import script from "./centralScheduling.vue?vue&type=script&lang=js&"
export * from "./centralScheduling.vue?vue&type=script&lang=js&"
import style0 from "./centralScheduling.vue?vue&type=style&index=0&id=6a56f6ca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a56f6ca",
  null
  
)

export default component.exports